<!-- <div class="divHome">
    <p>CONTADOR</p>
    <h1>{{contador}}</h1>


    <button (click)="incrementar()">+</button>
    <button (click)="decrementar()">-</button>

</div> -->

<!-- <app-hijo [contador]="contador" (cambioContador)="contador=$event"></app-hijo> -->
<router-outlet ></router-outlet>
